"use client";
import React, { ReactNode, useEffect, useRef } from "react";

const SmoothMobileCarouselWrapper = ({ children }: { children: ReactNode }) => {
  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    let firstClientX: number;

    const touchStart = (e: TouchEvent) => {
      firstClientX = e.touches[0].clientX;
    };

    const preventTouch = (e: TouchEvent) => {
      const minValue = 5;
      const clientX = e.touches[0].clientX - firstClientX;

      if (Math.abs(clientX) > minValue) {
        e.preventDefault();
      }
    };

    container.addEventListener("touchstart", touchStart);
    container.addEventListener("touchmove", preventTouch, { passive: false });

    return () => {
      container.removeEventListener("touchstart", touchStart);
      container.removeEventListener("touchmove", preventTouch);
    };
  }, []);

  return <div ref={containerRef}>{children}</div>;
};

export default SmoothMobileCarouselWrapper;
